import React from "react";
import PropTypes from "prop-types";
import StudioInfoModule from "./studioInfoModule";
import { Provider } from "react-redux";
import { createReduxStore } from "./redux/store";
import ErrorBoundary from "../../../../javascript/components/errorBoundary/errorBoundary";

const StudioInfo = (props) => (
  <Provider store={createReduxStore("studioInfoModule")}>
    <ErrorBoundary {...props.notifications} moduleName="StudioInfo">
      <StudioInfoModule currentUser={props.params} />
    </ErrorBoundary>
  </Provider>
);

StudioInfo.propTypes = {
  params: PropTypes.object,
  notifications: PropTypes.object
};
export default StudioInfo;
